<template>
    <div>
        <Exception type="500" img-color :desc="$t('page.exception.e500')" :back-text="$t('page.exception.btn')" />
    </div>
</template>
<script>
    export default {
        name:'plat-error500',
    }
</script>



// WEBPACK FOOTER //
// src/pages/error/500/index.vue